import React from 'react';

import { Organization } from '../../types/api.graphql';
import { DropDownProps } from '../Dropdown/Dropdown';
import InfiniteScrollDropdown from '../InfiniteScrollDropdown';
import { useOrganizationsDropdown } from './hook/useOrganizationsDropdown';

export const PAGE_ITEMS_COUNT = 10;

type InfiniteScrollDropdownSelection = number;

export interface OrganizationsDropdownProps extends Omit<DropDownProps, 'onSelectionChange'> {
  onSelectionChange?: (selection: InfiniteScrollDropdownSelection, organization: Organization) => void;
}

export interface DropdownItemProps {
  text: string;
  value?: any;
  description?: string;
  selected?: boolean;
  imageUrl?: string;
}

const OrganizationsDropdown = (props: OrganizationsDropdownProps) => {
  const { items, hasMore, selectedIndex, loadingFirst, loadingMore, handleLoadMore, handleItemSelection } =
    useOrganizationsDropdown(props.selectedIndex, props.onSelectionChange);

  return (
    <>
      <InfiniteScrollDropdown
        {...props}
        items={items}
        onSelectionChange={handleItemSelection}
        selectedIndex={selectedIndex}
        hasMore={hasMore}
        loadingFirst={loadingFirst}
        loadingMore={loadingMore}
        loadMore={() => void handleLoadMore()}
        getItemsHook={useOrganizationsDropdown}
      />
    </>
  );
};

export default OrganizationsDropdown;
